export default (id = null) => ({
  id,
  type: 'syncedContent',
  historyData: {},
  syncHistory: {},
  v: 0,
  hash: 0,
});



// WEBPACK FOOTER //
// ./src/data/empties/emptySyncedContent.js